var sellSwiper = new Swiper(".tb-ind-sell-swiper", {
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".swiper-pagination",
  },
  on: {
    init: function(swiper){
      let index = this.activeIndex;
      toggleFaq(index)
    }, 
    slideChangeTransitionStart: function(){
      let index = this.activeIndex;
      toggleFaq(index)
    }
  }
});
function toggleFaq(index){
  $('.index-sell-faq-item').show();
  $('.index-sell-faq-item').eq(index).addClass('active').siblings().removeClass('active');
  $('.index-sell-faq-item').find('dd').slideUp();
  $('.index-sell-faq-item').eq(index).find('dd').slideDown();
}



$('.index-sell-faq-item').click(function (e) { 
  e.preventDefault();
  let index = $(this).index();
  $(this).toggleClass('active').siblings().removeClass('active');
  $(this).siblings().find('dd').slideUp();
  $(this).find('dd').slideToggle();
  sellSwiper.slideTo(index, 1000, false);
});
$('.index-sell-faq-item dd').click((e) =>{e.stopPropagation()})

var swiper = new Swiper(".moduleNavigationSwiper", {
  slidesPerView: isMobile() ? 2.1 : 4,
  centeredSlides: isMobile() ? true : false,
});

$(document).ready(function() {
  // 获取当前页面的URL
  var currentPageUrl = window.location.href;

  // 判断每个链接是否匹配当前URL的锚点值
  $('.nav-anchor').each(function() {
    var anchorValue = $(this).data('anchor');
    if (currentPageUrl.indexOf(anchorValue) !== -1) {
      $(this).addClass('active');
    }
  });
});

$('.nav-anchor').click(function() {
  $('.nav-anchor').removeClass('active');
  $(this).addClass('active');
});


$('.product-add-cart-botton').on('click', function (e) {
  let id = $(this).data('variantid') || $(this).data('id');
  addCartFn(id)
})

var productShowThumbs = new Swiper(".product-content-1 .product-image-thumb-swiper", {
  slidesPerView: 3,
  freeMode: true,
  watchSlidesProgress: true,
  spaceBetween: isMobile() ? 5 : 10,
  loop: true,
  observer: true,
  observeParents: true,
  navigation: {
    nextEl: ".product-content-1 .product-image-thumb-swiper-button-next",
    prevEl: ".product-content-1 .product-image-thumb-swiper-button-prev",
  },
});

var productShowFull = new Swiper(".product-content-1 .product-image-show-swiper", {
  loop: true,
  slidesPerView: 1,
  observer: true,
  observeParents: true,
  thumbs: {
    swiper: productShowThumbs,
  },
});

var productShowThumbs2 = new Swiper(".product-content-2 .product-image-thumb-swiper", {
  slidesPerView: 3,
  freeMode: true,
  watchSlidesProgress: true,
  spaceBetween: isMobile() ? 5 : 10,
  loop: true,
  observer: true,
  observeParents: true,
  navigation: {
    nextEl: ".product-content-2 .product-image-thumb-swiper-button-next",
    prevEl: ".product-content-2 .product-image-thumb-swiper-button-prev",
  },
});

var productShowFull2 = new Swiper(".product-content-2 .product-image-show-swiper", {
  loop: true,
  slidesPerView: 1,
  observer: true,
  observeParents: true,
  thumbs: {
    swiper: productShowThumbs2,
  },
});

var swiper = new Swiper(".reviewSwiper", {
  slidesPerView: isMobile() ? 1 : 4.1,
  spaceBetween: 20,
  loop: true,
  navigation: {
    nextEl: ".review-card .swiper-button-next",
    prevEl: ".review-card .swiper-button-prev",
  },
  pagination: {
    el: ".review-card .swiper-pagination",
  },
});